import React, { useEffect, useRef, useState } from "react";
import "../CSS/About.css";
import Image1 from "../Images/SImage_1.jpg";
import Image2 from "../Images/SImage_2.jpg";
import Image3 from "../Images/SImage_3.jpg";
import Image4 from "../Images/SImage_4.jpg";
import Image5 from "../Images/SImage_5.jpg";
import Image6 from "../Images/SImage_6.jpg";
import { useNavigate } from "react-router-dom";
import axios from 'axios';

const About = () => {
  const stackRef = useRef(null);

  useEffect(() => {
    if (!stackRef.current) return; // Ensure stackRef is available

    const stack = stackRef.current;
    const cards = Array.from(stack.children)
      .reverse()
      .filter((child) => child.classList.contains("About_card"));

    cards.forEach((card) => stack.appendChild(card));

    const moveCard = () => {
      const lastCard = stack.lastElementChild;
      if (lastCard.classList.contains("About_card")) {
        lastCard.classList.add("swap");

        setTimeout(() => {
          lastCard.classList.remove("swap");
          stack.insertBefore(lastCard, stack.firstElementChild);
        }, 1200);
      }
    };

    let autoplayInterval = setInterval(moveCard, 4000);

    const handleCardClick = (e) => {
      const card = e.target.closest(".About_card");
      if (card && card === stack.lastElementChild) {
        card.classList.add("swap");

        setTimeout(() => {
          card.classList.remove("swap");
          stack.insertBefore(card, stack.firstElementChild);
        }, 1200);
      }
    };

    stack.addEventListener("click", handleCardClick);

    return () => {
      clearInterval(autoplayInterval);
      stack.removeEventListener("click", handleCardClick);
    };
  }, []);

   const navigate = useNavigate(); // Initialize navigate function
  
      const handleExploreClick = () => {
          navigate("/about"); // Navigate to /about
      };

      const [data,setData] = useState(null);

      useEffect(() => {
          const fetchData = async () => {
            try {
              const response = await axios.get("https://us-central1-balajibadmintonacademy.cloudfunctions.net/api/getAboutData");
              console.log('Fetched slide data:', response.data); 
              setData(response.data || {});
            } catch (error) {
              console.error('Error fetching data from backend:', error);
            }
          };
      
          fetchData();
        }, []);
  
  return (
    <div className="About_Section">
      <div className="About_main">
        <div className="About_content">
          <h1>{data?.title || "Default Title"}</h1>
          <p className="About_p">
            {data?.description || "Default Description"}
          </p>
          <button onClick={handleExploreClick} className="btn">Explore</button>
        </div>
        <div className="stack" ref={stackRef}>
          <div className="About_card">
            <img
              src={Image1}
              alt=""
            />
          </div>
          <div className="About_card">
            <img
              src={Image2}
              alt=""
            />
          </div>
          <div className="About_card">
            <img
              src={Image3}
              alt=""
            />
          </div>
          <div className="About_card">
            <img
              src={Image4}
              alt=""
            />
          </div>
          <div className="About_card">
            <img
              src={Image5}
              alt=""
            />
          </div>
          <div className="About_card">
            <img
              src={Image6}
              alt=""
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
